import { render, staticRenderFns } from "./VDialogActions.vue?vue&type=template&id=42f40ce0"
import script from "./VDialogActions.vue?vue&type=script&lang=js"
export * from "./VDialogActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f40ce0')) {
      api.createRecord('42f40ce0', component.options)
    } else {
      api.reload('42f40ce0', component.options)
    }
    module.hot.accept("./VDialogActions.vue?vue&type=template&id=42f40ce0", function () {
      api.rerender('42f40ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VDialog/VDialogActions.vue"
export default component.exports